import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UserInfo } from "../../service/Model/UserInfo";
import { UserinfoService } from "../../service/userinfo.service";
import { AppAdministrationKraft } from '../../kraft/app.administration.kraft';

@Component({
  selector: 'kraft-header-template',
  templateUrl: './kraft.header.template.html',
  styleUrls: ['./kraft.header.template.scss']
})
export class KraftHeaderTemplate implements OnInit, OnChanges {

  @Input()
  templateText: string;

  @Input()
  labelText: string;

  userInfo: UserInfo;

  tagesDatum: Date;

  constructor(private userinfoService: UserinfoService) {
  }

  ngOnInit() {
    //debugger;
    console.log("ngInit headerTemplate -- BEGINN");
    this.tagesDatum = new Date();

    this.userInfo = this.userinfoService.getUserinfo();
    console.log("headerTemplate - userinofo: " + this.userInfo);

    console.log(this.userInfo);
    console.log("ngInit headerTemplate -- ENDE");
  }

  ngOnChanges() {
    this.userInfo = this.userinfoService.getUserinfo();
  }

}
